var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8045 6.97708L15.2224 13.9825C15.2366 14.1737 15.1445 14.3013 15.0949 14.3579C15.0383 14.4217 14.9179 14.5208 14.7195 14.5208H12.7858L14.3158 6.97708H14.8045ZM15.5837 4.25L15.5766 4.26417C15.5908 4.43417 15.5766 4.61125 15.5341 4.78833L10.3137 14.3721C10.1437 15.0875 9.5062 15.5833 8.76953 15.5833H14.7195C15.6333 15.5833 16.3558 14.8113 16.2849 13.8975L15.5837 4.25Z",
    fill: "url(#paint0_linear_1500_2197)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11099 1.58666C8.18182 1.30332 8.00474 1.01291 7.72141 0.942073C7.43807 0.878323 7.14766 1.04832 7.07682 1.33166L6.72266 2.79791H7.81349L8.11099 1.58666Z",
    fill: "url(#paint1_linear_1500_2197)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7858 1.56539C12.8495 1.27498 12.6654 0.998727 12.3749 0.934977C12.0916 0.871227 11.8083 1.05539 11.7445 1.34581L11.4258 2.81206H12.5166L12.7858 1.56539Z",
    fill: "url(#paint2_linear_1500_2197)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4563 3.77535C15.2226 3.20869 14.6701 2.80494 13.9901 2.80494H12.5167L12.1201 4.63952C12.0634 4.88744 11.8438 5.05744 11.603 5.05744C11.5676 5.05744 11.5251 5.05744 11.4896 5.04327C11.2063 4.97952 11.0221 4.69619 11.0788 4.41285L11.4259 2.79785H7.81339L7.36714 4.63952C7.31048 4.88035 7.09089 5.04327 6.85006 5.04327C6.80756 5.04327 6.76506 5.03619 6.72256 5.0291C6.43923 4.95827 6.26214 4.67494 6.33298 4.38452L6.71548 2.79077H5.27756C4.58339 2.79077 3.96714 3.2441 3.76173 3.90994L0.779644 13.5079C0.467977 14.5349 1.22589 15.5833 2.29548 15.5833H11.603C12.3396 15.5833 12.9771 15.0874 13.1471 14.372L15.5342 4.78827C15.5767 4.61119 15.5909 4.4341 15.5767 4.2641C15.5626 4.0941 15.5271 3.9241 15.4563 3.77535ZM10.413 11.8645H4.74631C4.45589 11.8645 4.21506 11.6237 4.21506 11.3333C4.21506 11.0429 4.45589 10.802 4.74631 10.802H10.413C10.7034 10.802 10.9442 11.0429 10.9442 11.3333C10.9442 11.6237 10.7034 11.8645 10.413 11.8645ZM11.1213 9.03119H5.45464C5.16423 9.03119 4.92339 8.79035 4.92339 8.49994C4.92339 8.20952 5.16423 7.96869 5.45464 7.96869H11.1213C11.4117 7.96869 11.6526 8.20952 11.6526 8.49994C11.6526 8.79035 11.4117 9.03119 11.1213 9.03119Z",
    fill: "url(#paint3_linear_1500_2197)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1500_2197",
    x1: 8.26104,
    y1: 13.6884,
    x2: 18.4557,
    y2: 8.42353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1500_2197",
    x1: 6.62773,
    y1: 2.48538,
    x2: 8.42455,
    y2: 1.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1500_2197",
    x1: 11.333,
    y1: 2.4961,
    x2: 13.1192,
    y2: 1.48633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1500_2197",
    x1: -0.296671,
    y1: 13.4444,
    x2: 13.7455,
    y2: 0.737987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D4FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "assets/media/calendar-icon.82e59ef8104666b12a58269e7d224973.svg";
export { ForwardRef as ReactComponent };